export const messages = {
  configurePageTitle: 'Configure Billboard',
  updatePageTitle: 'Update Billboard',
  subtitle: 'Create display tiles without offer mechanics in the Experience app',
};
